<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

    <div
      style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden"
    >
      <userLeft :active="2" />
      <div class="box5">
        <div style="overflow: hidden">
          <div class="box6">
            您当前的账号 <span style="margin-left: 7%">{{obj.mobile}}</span>
          </div>
        </div>
        <div class="box7"></div>

        <div style="overflow: hidden; height: 60px; line-height: 60px">
          <img
            src="../assets/wangjimima_zhengque.png"
            style="width: 25px; height: 25px; float: left; margin-top: 15px"
            alt=""
          />
          <div class="item_base_txt">绑定手机</div>
          <div class="item_base_txt1">
            绑定手机号：{{obj.mobile}}，用于支付安全和收货提醒等，若手机丢失或停用，请及时更换
          </div>
          <router-link to="/change_tel"><div class="item_base_right">更换</div></router-link>
        </div>


        <div style="overflow: hidden; height: 60px; line-height: 60px">
          <img
            src="../assets/wangjimima_zhengque.png"
            style="width: 25px; height: 25px; float: left; margin-top: 15px"
            alt=""
          />
          <div class="item_base_txt">密码</div>
          <div class="item_base_txt1" style="margin-left: 65px;">
            建议您定期更换密码，可以使账号更安全
          </div>
          <router-link to="/chang_login_password"><div class="item_base_right">修改</div></router-link>
        </div>
        <div style="overflow: hidden; height: 60px; line-height: 60px">
          <img v-if="data === true"
            src="../assets/wangjimima_zhengque.png"
            style="width: 25px; height: 25px; float: left; margin-top: 15px"
            alt=""
          />
          <img v-else
            src="../assets/wangjimima_quxiao.png"
            style="width: 25px; height: 25px; float: left; margin-top: 15px"
            alt=""
          />
          <div class="item_base_txt">微信</div>
          <div class="item_base_txt1" style="margin-left: 65px;">
            通过微信快捷登录
          </div>
          <div v-if="data === true" class="item_base_right" @click="wxjiebang">解绑</div>
          <div v-else class="item_base_right" @click="wxdenglu">去绑定</div>
        </div>
        <div style="overflow: hidden; height: 60px; line-height: 60px">
          <img v-if="data1 === true"
            src="../assets/wangjimima_zhengque.png"
            style="width: 25px; height: 25px; float: left; margin-top: 15px"
            alt=""
          />
          <img v-else
            src="../assets/wangjimima_quxiao.png"
            style="width: 25px; height: 25px; float: left; margin-top: 15px"
            alt=""
          />
          <div class="item_base_txt">QQ</div>
          <div class="item_base_txt1" style="margin-left: 65px;">
            通过qq快捷登录
          </div>
          <div v-if="data1 === true" class="item_base_right" @click="qqjiebang">解绑</div>
          <div v-else class="item_base_right" @click="qqdenglu">去绑定</div>
        </div>
      </div>
    </div>
    <foot />
  </div>
</template>

<script>
import axios from "axios";
import userLeft from "../public/user_left";
import htmlHeader from "../public/head";
import foot from "../public/foot";
export default {
  name: "integral",
  components: {
    userLeft,
    htmlHeader,
    foot,
  },
  data() {
    return {
      obj: "",
      wx: 'WECHAT_OPEN',
      qq: 'QQ',
      data: null,
      data1: null,
    };
  },
  methods: {
    // QQ解绑
    qqjiebang () {
      this.$confirm({
        title: '确定解除QQ绑定吗？',
        onOk: () => this.api.wxjiebang(this.qq).then((data) => {
          this.$message.info(data.message)
          this.chaxunqq()
        })
      })
    },
    // QQ绑定
    qqdenglu () {
      var _this = this
      window.open(`/api/oauth/public/loginJump/${_this.qq}`, 'newwindow', 'height=500, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no')
      window.addEventListener('message', function (e) {
          _this.api.wxshenfen(e.data).then((i)=>{
            _this.$message.info(i.message)
            _this.chaxunqq()
          })
      }, false)
    },
    // 微信解绑
    wxjiebang () {
      this.$confirm({
        title: '确定解除微信绑定吗',
        onOk: () => this.api.wxjiebang(this.wx).then((data) => {
          this.$message.info(data.message)
          this.chaxunwx()
        })
      })
    },
    // 微信绑定
    wxdenglu () {
      var _this = this
      window.open(`/api/oauth/public/loginJump/${_this.wx}`, 'newwindow', 'height=500, width=500, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no')
      window.addEventListener('message', function (e) {
          _this.api.wxshenfen(e.data).then((i)=>{
            _this.$message.info(i.message)
            _this.chaxunwx()
          })
      }, false)
    },
    // 获取当前微信是否已绑定第三方
    chaxunwx: function () {
      this.api.wx_info(this.wx).then((data) => {
        this.data = data.data
      })
    },
    chaxunqq: function () {
      this.api.wx_info(this.qq).then((data) => {
        this.data1 = data.data
      })
    }
  },
  created() {
    // 获取我的信息
    this.api.user_info().then(res => {
      this.obj = res.data
    })
    // 获取当前用户是否已绑定微信
    this.chaxunwx()
    this.chaxunqq()
  },
};
</script>

<style scoped>
.item_base_right {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2c9a34;
  float: right;
  cursor: pointer;
}
.item_base_txt1 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  float: left;
  margin-left: 4%;
}
.item_base_txt {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  float: left;
  margin-left: 4%;
}
.box14 {
  width: 120px;
  height: 32px;
  border: 1px solid #2c9a34;
  float: right;
  text-align: center;
  line-height: 32px;

  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2c9a34;
}
.box13 {
  width: 16.6666%;
  height: 100%;
  float: left;

  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
}
.box12 {
  width: 100%;
  height: 40px;
  background: #f4f4f4;
  margin-top: 4%;
}
.box11 {
  width: 100px;
  height: 32px;
  border: 1px solid #2b9a34;
  margin: 8% auto;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2b9a34;
}

.box10 {
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff9629;
  /* line-height: 16px; */
  margin: 4% auto;
}

.box9 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin: auto;
}

.box8 {
  width: 100%;
  height: 105px;
  background: EEF7EF;
  /* opacity: 0.08; */
  padding-top: 4%;
}

.box7 {
  width: 100%;
  height: 1px;
  border-top: 1px solid #e8e6e6;
  margin-top: 2%;
}

.box6 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  /* margin-top: 2%; */
  text-align: left;
}

.box5 {
  width: 80%;
  min-height: 1023px;
  border: 1px solid #ede9e9;
  float: right;
  margin-top: 2%;
  padding: 2%;
}

.box3 {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: Regular;
  color: #666666;
  margin-top: 6%;
}

.box4 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}

.box1 {
  width: 220px;
  min-height: 1023px;
  border: 1px solid #ede9e9;
  float: left;
  margin-top: 2%;
}

.box2 {
  width: 100%;
  height: 45px;
  background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/account_security.vue